import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import "./WhatsAppWorld.css";

/*
 * La posición, el color y la clase visual siguen siendo
 * responsabilidad del componente.
 *
 * Los textos visibles se obtienen desde home.json.
 */
const FLOATING_ITEM_CONFIG = [
  {
    id: "mentors",
    className: "is-mentors",
    color: "#8d5cff",
  },
  {
    id: "internships",
    className: "is-internships",
    color: "#28d86f",
  },
  {
    id: "scholarships",
    className: "is-scholarships",
    color: "#ef58c8",
  },
  {
    id: "money",
    className: "is-money",
    color: "#ffb51c",
  },
  {
    id: "projects",
    className: "is-projects",
    color: "#ffb51c",
  },
  {
    id: "card",
    className: "is-card",
    color: "#ef58c8",
  },
  {
    id: "loans",
    className: "is-loans",
    color: "#4f9cff",
  },
  {
    id: "first-job",
    className: "is-first-job",
    color: "#ef58c8",
  },
  {
    id: "discounts",
    className: "is-discounts",
    color: "#ff7a35",
  },
  {
    id: "courses",
    className: "is-courses",
    color: "#8d5cff",
  },
  {
    id: "community",
    className: "is-community",
    color: "#28d86f",
  },
  {
    id: "expenses",
    className: "is-expenses",
    color: "#28d86f",
  },
];

export default function WhatsAppWorld() {
  const { t } = useTranslation("home");

  const floatingItems = useMemo(() => {
    const translatedItems = t("whatsappWorld.floatingItems", {
      returnObjects: true,
    });

    if (!Array.isArray(translatedItems)) {
      return [];
    }

    return FLOATING_ITEM_CONFIG.map((configItem) => {
      const translatedItem = translatedItems.find(
        (item) => item.id === configItem.id,
      );

      return {
        ...configItem,
        label: translatedItem?.label ?? configItem.id,
      };
    });
  }, [t]);

  return (
    <section
      className="whatsapp-world"
      aria-labelledby="whatsapp-world-title"
      aria-label={t("whatsappWorld.accessibility.sectionLabel")}
    >
      <div className="whatsapp-world__rings" aria-hidden="true">
        <span className="whatsapp-world__ring whatsapp-world__ring--one" />
        <span className="whatsapp-world__ring whatsapp-world__ring--two" />
        <span className="whatsapp-world__ring whatsapp-world__ring--three" />
      </div>

      <div
        className="whatsapp-world__floating-layer"
        aria-label={t("whatsappWorld.accessibility.floatingItemsLabel")}
      >
        {floatingItems.map((item, index) => (
          <span
            key={item.id}
            className={["whatsapp-world__item", item.className].join(" ")}
            style={{
              "--item-color": item.color,
              "--animation-delay": `${index * -0.65}s`,
            }}
          >
            {item.label}

            <i aria-hidden="true" />
          </span>
        ))}
      </div>

      <div className="whatsapp-world__content">
        <h2 id="whatsapp-world-title">
          <span className="whatsapp-world__title-top">
            {t("whatsappWorld.title.top")}
          </span>

          <span className="whatsapp-world__title-bottom">
            {t("whatsappWorld.title.bottomBefore")}{" "}
            <strong>{t("whatsappWorld.title.highlight")}</strong>
          </span>
        </h2>
      </div>
    </section>
  );
}
